import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import SignInForm from "../components/Login/SignInForm";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
// import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import SpeedRoundedIcon from "@mui/icons-material/SpeedRounded";

const Root = styled(Box)(({ theme }) => ({
  minHeight: "100dvh",
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr",
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "1.25fr 1fr",
  },
}));

const Left = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(6),
  position: "relative",
  background: `
    radial-gradient(circle at 20% 20%, ${theme.palette.primary.main}22, transparent 55%),
    radial-gradient(circle at 80% 70%, ${theme.palette.primary.main}14, transparent 50%),
    linear-gradient(135deg, ${theme.palette.primary.main}10, ${theme.palette.background.default})
  `,
  borderRight: theme.palette.mode === "dark"
    ? "1px solid rgba(255,255,255,0.08)"
    : "1px solid rgba(0,0,0,0.06)",
}));

const Right = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3),
  background: theme.palette.mode === "dark"
    ? "transparent"
    : "rgba(255,255,255,0.55)",
}));

function Bullet({ icon, title, desc }) {
  return (
    <Box sx={{ display: "flex", gap: 1.4, alignItems: "flex-start", mt: 2 }}>
      <Box
        sx={(theme) => ({
          width: 40,
          height: 40,
          borderRadius: 3,
          display: "grid",
          placeItems: "center",
          bgcolor: `${theme.palette.primary.main}1a`,
          border: `1px solid ${theme.palette.primary.main}30`,
          flexShrink: 0,
          "& svg": { fontSize: 22, color: theme.palette.primary.main },
        })}
      >
        {icon}
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 900 }}>{title}</Typography>
        <Typography variant="body2" sx={{ opacity: 0.75, maxWidth: 420 }}>
          {desc}
        </Typography>
      </Box>
    </Box>
  );
}

export default function SignIn() {
  return (
    <Root>
      <Left>
        <Typography sx={{ fontSize: 34, fontWeight: 950, lineHeight: 1.1 }}>
          JEX
        </Typography>
        <Typography sx={{ mt: 1, opacity: 0.75, maxWidth: 520 }}>
          Juridico de Expedientes. Accedé para
          administrar expedientes, escritos y reportes.
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Bullet
            icon={<GavelRoundedIcon />}
            title="Gestión centralizada"
            desc="Expedientes, títulos, escritos y reportes en un solo lugar."
          />
          {/* <Bullet
            icon={<VerifiedUserRoundedIcon />}
            title="Acceso seguro"
            desc="Permisos por rol y trazabilidad de operaciones."
          /> */}
          <Bullet
            icon={<SpeedRoundedIcon />}
            title="Flujo ágil"
            desc="Búsqueda rápida, filtros y procesos automatizados."
          />
        </Box>

        {/* <Typography variant="caption" sx={{ mt: 6, opacity: 0.6 }}>
          © {new Date().getFullYear()} JEX
        </Typography> */}
      </Left>

      <Right>
        <Container
          maxWidth={false}
          disableGutters
          sx={{ width: "100%", maxWidth: 520 }}
        >
          <SignInForm />
        </Container>
      </Right>
    </Root>
  );
}


// import React from "react";
// import { Box, Container } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import SignInForm from "../components/Login/SignInForm";

// const Root = styled(Box)(({ theme }) => ({
//   minHeight: "100dvh",
//   width: "100%",
//   display: "grid",
//   placeItems: "center",
//   position: "relative",
//   background: `
//     radial-gradient(circle at 20% 20%, ${theme.palette.primary.main}22, transparent 55%),
//     radial-gradient(circle at 80% 70%, ${theme.palette.primary.main}14, transparent 50%),
//     linear-gradient(135deg, ${theme.palette.primary.main}10, ${theme.palette.background.default})
//   `,
// }));

// export default function SignIn() {
//   return (
//     <Root>
//       <Container
//         maxWidth={false}
//         disableGutters
//         sx={{
//           px: { xs: 2, sm: 3 },
//           width: "100%",
//           maxWidth: 520,
//         }}
//       >
//         <SignInForm />
//       </Container>
//     </Root>
//   );
// }
